var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNewAvailabilityIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 31,
  height: 31,
  viewBox: "0 0 31 31",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.5 30.5h30V.5H.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.5 26.5h-24a1 1 0 0 1-1-1v-19a1 1 0 0 1 1-1h24a1 1 0 0 1 1 1v19a1 1 0 0 1-1 1z",
  stroke: "#FFF",
  strokeWidth: 1.036,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.5 24.5H3.345a.845.845 0 0 1-.845-.845v-13.31c0-.467.378-.845.845-.845h24.31c.467 0 .845.378.845.845V19.5a5 5 0 0 1-5 5zM6.067 7h-.134a.434.434 0 0 1-.433-.433V4.433c0-.238.195-.433.433-.433h.134c.238 0 .433.195.433.433v2.134A.434.434 0 0 1 6.067 7zM10.067 7h-.134a.434.434 0 0 1-.433-.433V4.433c0-.238.195-.433.433-.433h.134c.238 0 .433.195.433.433v2.134a.434.434 0 0 1-.433.433zM21.067 7h-.134a.434.434 0 0 1-.433-.433V4.433c0-.238.195-.433.433-.433h.134c.238 0 .433.195.433.433v2.134a.434.434 0 0 1-.433.433zM25.067 7h-.134a.434.434 0 0 1-.433-.433V4.433c0-.238.195-.433.433-.433h.134c.238 0 .433.195.433.433v2.134a.434.434 0 0 1-.433.433zM2.5 9.5h26",
  stroke: "#FFF",
  strokeWidth: 1.036,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.5 24.5c1-2 1-4 1-4s4-.969 4-2",
  stroke: "#FFF",
  strokeWidth: 1.036,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.5 19.44c0 .404-.315.751-.729.817-.909.124-1.818.206-2.736.239l-.693.017c-.108 0-.225.008-.342.008-.117 0-1.035-.025-1.035-.025a27.514 27.514 0 0 1-2.736-.239c-.414-.066-.729-.413-.729-.817 0-.239.108-.777.297-.934a.897.897 0 0 1 .333-.165l.216-.287c.126-.371.189-.759.189-1.147v-1.006c0-1.486 1.035-2.74 2.448-3.152a3.424 3.424 0 0 1 2.034 0c1.413.412 2.448 1.666 2.448 3.152v1.006c0 .388.063.776.189 1.147l.216.287a.897.897 0 0 1 .333.165c.189.157.297.695.297.934z",
  stroke: "#FFF",
  strokeWidth: 0.968,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.085 12.328c0-.483.403-.875.9-.875s.9.392.9.875M16.9 20.894c0 .335-.403.606-.9.606s-.9-.271-.9-.606M12.285 18.32c.5.107 1.98.39 3.716.4 1.12.006 2.532-.1 3.67-.44",
  stroke: "#FFF",
  strokeLinecap: "round"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNewAvailabilityIcon);
export default ForwardRef;